export async function runAsyncWithTimeMeasurement<T>(
  fn: () => Promise<T>
): Promise<{
  response: T;
  deltaTime: number;
}> {
  const initialTime = new Date().getTime();

  const response = await fn();

  const newTime = new Date().getTime();
  const deltaTime = newTime - initialTime;

  return { response, deltaTime };
}
